import { isTouch } from '../../configuration/Configuration.js';
import fulfill from '../../helpers/promise/fulfill.js';
import getTopReviews from '../../scripts/api/reviews/getTopReviews.js';
import componentRegistry from '../registry.js';
import './index.less';

// TODO merge with SellerProfileOverview
export default class ProductReviewsOverview {
  #loaded = false;
  #content;

  constructor({ el }) {
    this.el = el;
    this.#content = this.el.querySelector('.js-TopReviews-content');

    if (!isTouch) {
      this.el.addEventListener('mouseover', this.#showContent);
      this.el.addEventListener('mouseleave', this.#hideContent);
    }
  }

  #hideContent = () => {
    this.#content.classList.remove('isActive');
  };

  #showContent = async () => {
    if (!this.#loaded) {
      const { prid, catalog, fragment } = this.el.dataset;
      this.#content.innerHTML = await fulfill(getTopReviews({ prid, catalog, fragment }), '');
      this.#loaded = true;
    }

    this.#content.classList.add('isActive');
  };
}

componentRegistry.define('js-TopReviews', ProductReviewsOverview);
